import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum EUserRoute {
  myProfile = 'myProfile',
  users = 'users',
}

CamRoutes.addRoute({
  key: EUserRoute.users,
  url: 'users',
  children: [
    {
      key: EUserRoute.myProfile,
      url: 'my-profile',
    },
  ],
});

export const userRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([EUserRoute.users, EUserRoute.myProfile]),
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([EUserRoute.users, EUserRoute.myProfile]),
    loadComponent: () => import('./pages/my-profile/my-profile.component').then(c => c.MyProfilePage),
  },
];
